import _ from 'underscore';
import Backbone from 'backbone';

// BAPI 응답코드
var SUCCESS = 1;

// 응답값 캐싱할 시간
var PSTK_TTL = 1000 * 10;

var GameStarterModel = Backbone.Model.extend({
  url: 'launcher',

  defaults: function () {
    return {
      resultCode: null,
      customURIScheme: '',
      message: '',
      isValidParam: false,
      createdAt: null,
      ssn: 0,
      gameInfoSrl: 0,
      label: 0
    };
  },

  parse: function (res) {
    var result = res.result;
    return {
      resultCode: result.resultCode,
      customURIScheme: result.customURIScheme,
      message: result.message || '',
      isValidParam: !!result.customURIScheme,
      createdAt: new Date().getTime()
    };
  },

  fetchParams: function (game, ssn, gameInfoSrl, channelLabel) {
    var now = new Date().getTime();
    var createdAt = this.get('createdAt');
    var isValidParam = this.get('isValidParam');
    var isSameGame = this.get('ssn') === ssn && this.get('gameInfoSrl') === gameInfoSrl;
    var cached;

    // 커스텀 URI 캐싱
    if (isSameGame && isValidParam && createdAt && now - createdAt <= PSTK_TTL) {
      cached = $.Deferred();
      cached.resolve(this.get('customURIScheme'));
      return cached.promise();
    }

    return this.save({ game: game, ssn: ssn, gameInfoSrl: gameInfoSrl, label: channelLabel })
      .then(this.parse)
      .then(
        _.bind(function (values) {
          var dfd = $.Deferred();
          var resultCode = values.resultCode;
          var customURIScheme = values.customURIScheme;
          var message = values.message;

          if (resultCode === SUCCESS) {
            dfd.resolve(customURIScheme);
          } else {
            dfd.reject({
              code: resultCode,
              description: message,
              customURIScheme: customURIScheme
            });
          }

          return dfd.promise();
        }, this)
      );
  }
});

export default GameStarterModel;
